import { jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import FavoritesApi from "./../../api/FavoritesApi.js";
import { ReactComponent as FavoritesStarIcon } from "./../../assets/icons/favorite-star.svg";
import "./favoritesComponent.css";
import { Spin } from "antd";
const FavoritesComponent = ({
  className = "",
  category,
  itemId,
  isFavorite,
  disabled,
  callback
}) => {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(isFavorite);
  const selectedRef = useRef(selected);
  useEffect(() => {
    setCurrentSelected(isFavorite);
  }, [isFavorite]);
  const setCurrentSelected = (value) => {
    selectedRef.current = value;
    setSelected(value);
    setTimeout(() => setLoading(false), 300);
  };
  const setFavoriteApi = async () => {
    setLoading(true);
    const apiCall = !selectedRef.current ? FavoritesApi.setFavorite() : FavoritesApi.deleteFavorite();
    return await apiCall.call({
      category,
      itemId
    }).then(() => true).catch(() => false);
  };
  const toggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || loading)
      return;
    const saved = await setFavoriteApi();
    if (saved) {
      setCurrentSelected(!selectedRef.current);
      if (callback) {
        setTimeout(() => {
          callback == null ? void 0 : callback();
        }, 200);
      }
      return;
    }
    setCurrentSelected(selectedRef.current);
  };
  return /* @__PURE__ */ jsx("div", { className: "favorites-component-wrapper", children: /* @__PURE__ */ jsx(
    Spin,
    {
      spinning: false,
      size: "large",
      indicator: /* @__PURE__ */ jsx(LoadingOutlined, { spin: true }),
      className: "favorites-component-spin",
      children: /* @__PURE__ */ jsx(
        FavoritesStarIcon,
        {
          className: `favorite-star ${selected ? "selected" : ""} ${disabled ? "disabled" : ""} ${className}`,
          onClick: toggleFavorite
        }
      )
    }
  ) });
};
var stdin_default = FavoritesComponent;
export {
  stdin_default as default
};
